// Offres RACINES 2026 — source unique de vérité.
// Partagé par Pricing.js et Checkout.js.

// Tarif annuel = 10 mois payés (2 mois offerts) ; annualFull = 12 mois plein
// tarif, affiché barré en regard.
export const PLANS = [
  {
    id: "fidelity",
    num: "N°01",
    nickname: "Les racines",
    name: "Fidelity Card",
    tier: "Essentiel",
    description:
      "La carte de fidélité dans le téléphone de vos clients, via Apple Wallet & Google Wallet. Un QR code au comptoir, zéro application, zéro carte physique perdue.",
    monthly: 39.99,
    monthlyFull: null,
    annual: 399.9,
    annualFull: 479.88,
    setupNote: "0 € de frais de mise en place",
    annualBadge: "2 mois offerts",
  },
  {
    id: "premium",
    num: "N°02",
    nickname: "Le tronc",
    name: "Fidelity-Card Premium",
    tier: "Premium",
    description:
      "La Fidelity Card à vos couleurs — logo, tampons, points — plus le tableau de bord complet : points distribués, clients actifs, tendances. Toute la visibilité pour piloter votre fidélisation.",
    monthly: 44.99,
    monthlyFull: null,
    annual: 449.9,
    annualFull: 539.88,
    setupNote: "0 € de frais de mise en place",
    annualBadge: "2 mois offerts",
    featured: true,
    featuredBadge: "La plus populaire",
  },
  {
    id: "extra",
    num: "N°03",
    nickname: "Les fruits",
    name: "Fidelity-Extra",
    tier: "Extra",
    description:
      "Tout Premium — carte et tableau de bord — plus vos campagnes de publicité par e-mail pour faire revenir vos clients, saison après saison.",
    monthly: 94.99,
    monthlyFull: null,
    annual: 949.9,
    annualFull: 1139.88,
    setupNote: "0 € de frais de mise en place",
    annualBadge: "2 mois offerts",
  },
];

// Tableau comparatif — chaque ligne liste les ids de plans qui incluent la fonctionnalité.
export const FEATURES = [
  {
    label: "Carte de fidélité Apple Wallet & Google Wallet",
    plans: ["fidelity", "premium", "extra"],
  },
  {
    label: "QR code d'inscription au comptoir",
    plans: ["fidelity", "premium", "extra"],
  },
  {
    label: "Scans et crédits de points illimités",
    plans: ["fidelity", "premium", "extra"],
  },
  {
    label: "Personnalisation de la carte (logo, couleurs, tampons, points)",
    plans: ["premium", "extra"],
  },
  {
    label: "Tableau de bord : clients actifs, points, tendances",
    plans: ["premium", "extra"],
  },
  {
    label: "Statistiques de fidélisation en temps réel",
    plans: ["premium", "extra"],
  },
  {
    label: "Campagnes de publicité par e-mail",
    plans: ["extra"],
  },
  {
    label: "E-mails et SMS automatiques, déclenchés selon vos règles",
    // Mot mis en gras dans le tableau comparatif.
    strong: "automatiques",
    plans: ["extra"],
  },
  {
    label: "Messages personnalisés au nom de votre commerce",
    plans: ["extra"],
  },
];

// Arguments communs affichés sous le tableau comparatif.
export const PRICING_NOTES = [
  {
    title: "0 € de mise en place",
    text: "Quelle que soit la formule : création de votre carte, paramétrage et QR code du comptoir compris.",
  },
  {
    title: "2 mois offerts",
    text: "Sur chaque formule annuelle, puis reconduction au tarif mensuel. Sans engagement caché.",
  },
  {
    title: "Changez quand vous voulez",
    text: "On passe d'une formule à l'autre à tout moment, sans refaire vos cartes ni perdre vos points.",
  },
];

export const CONTACT = {
  phone: "07 81 62 39 59",
  email: "amir.bendjelid@racines-project.com",
  site: "racines-project.com",
};

// Identité légale affichée sur les pages /mentions-legales, /confidentialite
// et /cgv. ⚠ Les champs « À compléter » doivent être renseignés avant toute
// communication commerciale — ils sont affichés tels quels.
export const COMPANY = {
  name: "Racines",
  legalForm: "", // ex. « SAS au capital de 1 000 € » — À compléter
  siret: "À compléter",
  address: "adresse du siège à compléter",
  publisher: "Amir Bendjelid",
  legalUpdated: "2 septembre 2026",
};

export function getPlan(id) {
  // Repli sur l'offre d'entrée : afficher le plan le plus cher sur un id
  // inconnu ferait payer au client autre chose que ce qu'il a choisi.
  return PLANS.find((p) => p.id === id) || PLANS[0];
}

export function formatPrice(value) {
  return value.toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
